import { Component, OnInit } from '@angular/core';
import { CacheService } from 'src/app/core/services/shared/cache.service';
import { DateService } from 'src/app/core/services/shared/date.service';
import { IpService } from 'src/app/core/services/shared/ip.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  directionIP: string;
  lastSesion: string;

  constructor(
    private _ipService: IpService,
    private _dateService: DateService,
    private _cacheService: CacheService
  ) {
  }

  ngOnInit(): void {
    this.getPublicIp()
    this.getDate()
  }

  getPublicIp(){
    const ip = this._cacheService.get("ip");
    if(ip){
      this.directionIP = ip.toString();
    }
    else{
      this._ipService.getPublicIp().then((data: any) => {
        this.directionIP = data;
        this._cacheService.set("ip", data)
      }).catch((err)=>{
        this.directionIP = "";
      });
    }
  }

  getDate(){
    const lastDate = this._cacheService.get("lastDate");
    const fecha = new Date();
    const month = this._dateService.getMonth(fecha.getMonth() + 1);
    const day = this._dateService.getDay(fecha.getDay());
    const meridiem = this._dateService.getMeridiem(fecha.getHours());
    const minutes = fecha.getMinutes() <= 9? "0" + fecha.getMinutes(): fecha.getMinutes();
    const hours = fecha.getHours() <= 9? "0" + fecha.getHours(): fecha.getHours();
    const actualDate = `${day} ${fecha.getDate()} de ${month} de ${fecha.getFullYear()} ${hours}:${minutes} ${meridiem}`;
    if(lastDate){
      this.lastSesion = lastDate.toString();
      this._cacheService.set("lastDate", actualDate)
    }
    else{
      this.lastSesion = actualDate;
    }
  }
  

}
